import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import moment from "moment-timezone";

dayjs.extend(utc);

export const UTC = "utc";
export const LOCAL = "local";

const STORAGE_KEY = "nuncTimezone";

const readStoredMode = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === UTC || stored === LOCAL ? stored : null;
  } catch (e) {
    return null; // storage can be blocked (private mode, embedded frames)
  }
};

// The browser's IANA zone, e.g. "Asia/Kolkata".
export const getLocalTimezoneName = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

// Local time unless the viewer has chosen UTC on a previous visit.
let currentMode = readStoredMode() || LOCAL;

// Moment is used all over V1. Giving it a default zone makes every
// `moment(x)` / `moment()` / `.startOf("day")` follow the selected mode
// without touching each call site. No argument resets it to browser-local.
const applyToMoment = (mode) => {
  moment.tz.setDefault(mode === UTC ? "UTC" : undefined);
};
applyToMoment(currentMode);

export const getTimezoneMode = () => currentMode;

export const isUtc = () => currentMode === UTC;

export const setTimezoneMode = (mode) => {
  if (mode !== UTC && mode !== LOCAL) return;
  currentMode = mode;
  applyToMoment(mode);
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch (e) {
    // the choice just won't persist across visits
  }
};

// dayjs in the selected zone. Use for anything that reads calendar fields
// (year/month/date/format) so UTC viewers and local viewers agree on the day.
export const tzDayjs = (input) => (isUtc() ? dayjs.utc(input) : dayjs(input));

// "UTC", or the browser's IANA zone when showing local time.
export const getTimezoneLabel = () => (isUtc() ? "UTC" : getLocalTimezoneName());
